/* infinite scroll 2026-10-09 — replaces visible pagination on collection + search grids.
   No-JS / crawler fallback: the theme pagination + a rel="next" link stay in the HTML (pagination is only visually hidden once JS runs).
   Next pages come from the Section Rendering API (?page=N&section_id=…). Cards are custom elements (card-swipe), so photo swipe self-initialises;
   grid-density listens for the 'inti:grid-append' event. Re-inits automatically when filters/sort replace #ProductGridContainer. */
(function () {
  var container = document.getElementById('ProductGridContainer');
  if (!container || !('IntersectionObserver' in window)) return;
  var io = null, loading = false, state = null;
  var pendingAfterGesture = false;
  document.addEventListener('inti:gesture-end', function () {
    if (!pendingAfterGesture || !state) return; pendingAfterGesture = false;
    if (state.sentinel.getBoundingClientRect().top < innerHeight + 1200) load(state);
  });
  function key(li) { var a = li.querySelector('a[href*="/products/"]'); return a ? a.getAttribute('href').split('?')[0] : li.textContent.trim().slice(0, 80); }
  function init() {
    if (io) { io.disconnect(); io = null; }
    var list = container.querySelector('ul.product-grid');
    var next = container.querySelector('a.inti-next-page');
    if (!list || !next) { state = null; container.classList.remove('inti-inf'); return; }
    if (list.dataset.inf === '1') return;
    list.dataset.inf = '1';
    container.classList.add('inti-inf');
    var seen = {};
    list.querySelectorAll(':scope > li').forEach(function (li) { seen[key(li)] = 1; });
    var sentinel = document.createElement('div');
    sentinel.className = 'inti-inf__sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    list.parentNode.insertBefore(sentinel, list.nextSibling);
    var status = document.createElement('p');
    status.className = 'inti-inf__status visually-hidden'; status.setAttribute('role', 'status');
    sentinel.after(status);
    state = { list: list, next: next.href, sid: next.dataset.sectionId, seen: seen, sentinel: sentinel, status: status };
    io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) load(state); }, { rootMargin: '0px 0px 1200px 0px' });
    io.observe(sentinel);
  }
  function load(st) {
    if (loading || !st || !st.next || st !== state) return;
    if (window.__intiGesture) { pendingAfterGesture = true; return; } // never fetch/append mid-pinch
    loading = true;
    var url = new URL(st.next, location.href); url.searchParams.set('section_id', st.sid);
    fetch(url.toString(), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      if (st !== state) return; // filters changed meanwhile
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var frag = document.createDocumentFragment(), added = [];
      doc.querySelectorAll('ul.product-grid > li').forEach(function (li) {
        var k = key(li); if (st.seen[k]) return; st.seen[k] = 1;
        li.querySelectorAll('img').forEach(function (img) { img.loading = 'lazy'; img.removeAttribute('fetchpriority'); });
        added.push(li); frag.appendChild(document.importNode(li, true));
      });
      st.list.appendChild(frag);
      var n = doc.querySelector('a.inti-next-page');
      st.next = n ? new URL(n.getAttribute('href'), location.href).toString() : null;
      st.status.textContent = added.length + ' more products loaded';
      st.list.dispatchEvent(new CustomEvent('inti:grid-append', { bubbles: true, detail: { count: added.length } }));
      if (!st.next) { io && io.disconnect(); st.sentinel.remove(); container.querySelectorAll('.pagination-wrapper').forEach(function (p) { p.remove(); }); }
    }).catch(function () { /* leave the visible fallback link usable */ container.classList.remove('inti-inf'); })
      .finally(function () {
        loading = false;
        // if the sentinel is still on screen (short pages), keep going
        if (st.next && st === state) { var r = st.sentinel.getBoundingClientRect(); if (r.top < innerHeight + 1200) load(st); }
      });
  }
  init();
  // fallback for fast flings that jump past the observer zone: one cheap rect read per frame at most, only while scrolling
  var tick = 0;
  addEventListener('scroll', function () {
    if (tick || !state || !state.next || loading) return;
    tick = requestAnimationFrame(function () { tick = 0; if (state && state.sentinel.getBoundingClientRect().top < innerHeight + 1200) load(state); });
  }, { passive: true });
  new MutationObserver(function () { var l = container.querySelector('ul.product-grid'); if (l && l.dataset.inf !== '1') init(); else if (!l) init(); })
    .observe(container, { childList: true, subtree: false });
})();
